module.exports = __webpack_public_path__ + "img/shipping.def1c70c.svg";